var map = {
	"./android.svg": "f094",
	"./api.svg": "1ab9",
	"./apk.svg": "1001",
	"./appgallery.svg": "a0ea",
	"./apple.svg": "f9d5",
	"./arrow-down.svg": "c874",
	"./arrow-right.svg": "cd8c",
	"./barcode.svg": "b632",
	"./bitcointalk.svg": "4666",
	"./btc.svg": "15a0",
	"./checkmark.svg": "1ec3",
	"./chevron-bottom.svg": "db57",
	"./chevron-down.svg": "1755",
	"./chevron-up.svg": "bb5d",
	"./content-copy-white.svg": "becb",
	"./content-copy.svg": "4e39",
	"./cookie.svg": "aac3",
	"./copy.svg": "8aac",
	"./create-structure.svg": "11c2",
	"./cross.svg": "2ad7",
	"./danger.svg": "f6f2",
	"./devider.svg": "a596",
	"./facebook-copy.svg": "436c",
	"./facebook.svg": "8485",
	"./green-arrow.svg": "e718",
	"./green-check.svg": "8315",
	"./instagram-copy.svg": "a958",
	"./instagram.svg": "bd6c",
	"./ios.svg": "f360",
	"./join-structure.svg": "34ff",
	"./langs/ae.svg": "4ca2",
	"./langs/ar.svg": "cadb",
	"./langs/bd.svg": "5edd",
	"./langs/cn.svg": "4ff8",
	"./langs/de.svg": "0396",
	"./langs/es.svg": "694c",
	"./langs/fr.svg": "2a9a",
	"./langs/id.svg": "8a8a",
	"./langs/in.svg": "b4ad",
	"./langs/it.svg": "7bc1",
	"./langs/jp.svg": "ff7b",
	"./langs/kh.svg": "9431",
	"./langs/kr.svg": "ba47",
	"./langs/mm.svg": "3755",
	"./langs/my.svg": "e8a1",
	"./langs/ph.svg": "b5e0",
	"./langs/pt.svg": "24fb",
	"./langs/ru.svg": "1d6d",
	"./langs/th.svg": "aaa0",
	"./langs/tr.svg": "c9e8",
	"./langs/us.svg": "38ce",
	"./last_update.svg": "33cc",
	"./linux.svg": "cc69",
	"./login.svg": "ca2f",
	"./logo.svg": "5b1c",
	"./logo_legend.svg": "6e3d",
	"./magnify.svg": "e5bd",
	"./medium.svg": "4f40",
	"./more.svg": "0f4c",
	"./mouse.svg": "5055",
	"./open-in-new.svg": "a54b",
	"./problem.svg": "42be",
	"./red-arrow.svg": "b090",
	"./red-check.svg": "1a1a",
	"./reddit.svg": "dcf1",
	"./repositories.svg": "1ec0",
	"./search_green.svg": "d90c",
	"./secure-subpage.svg": "9865",
	"./secure.svg": "2390",
	"./send.svg": "5b6e",
	"./sign.svg": "8ef8",
	"./sign_green.svg": "a33f",
	"./sign_red.svg": "cd1d",
	"./solution.svg": "fa95",
	"./speed.svg": "6c2d",
	"./speedometer.svg": "71c6",
	"./staking.svg": "de72",
	"./stars.svg": "fe08",
	"./subscribers.svg": "c993",
	"./symbol.svg": "8348",
	"./tabs/addresses.svg": "f5b3",
	"./tabs/blocks.svg": "5c68",
	"./tabs/burned.svg": "f0b7",
	"./tabs/gitlab.svg": "4f14",
	"./tabs/prices.svg": "65f1",
	"./tabs/structures.svg": "40f1",
	"./tabs/transactions.svg": "c940",
	"./tabs/umi.svg": "232b",
	"./telegram.svg": "2b29",
	"./tik_tok.svg": "a50b",
	"./twitter.svg": "acf9",
	"./vk.svg": "13e3",
	"./vkontakte.svg": "5699",
	"./wallet-blue.svg": "2c85",
	"./wallet-green.svg": "2374",
	"./wallet-red.svg": "ab0b",
	"./wallet.svg": "4f4a",
	"./windows.svg": "8b1e",
	"./youku.svg": "c6ca",
	"./youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";